import { graphql } from "msw";
import { mockProduct } from "./mockProduct";
import { CartUpsellRecommendationQuery } from "@cart-app/generated/graphql";

const recommendedProduct = {
  ...mockProduct,
  title: "Recommended 48 x Cadbury Caramello Egg 39g",
};

export const handler = graphql.query<CartUpsellRecommendationQuery>(
  "CartUpsellRecommendation", // CartUpsellRecommendation.tsx
  (_request, response, context) =>
    response(
      context.data({
        __typename: "Query" as const,
        cartUpsellRecommendation: {
          __typename: "CartUpsellResponse" as const,
          product: recommendedProduct,
          metaData: {
            hydrationErrorCount: 0,
            preHydrationCount: 1,
            postHydrationCount: 1,
            __typename: "RecommenderMetaData" as const,
          },
        },
      })
    )
);
